<template>
	<transition name="slide" appear>
		<type-wrapper class="type-J" regular v-if="isShow">
			<type-grid row="34">
				<type-text type="content" size="9">
					This website or its third-party tools use cookies,
					which are necessary to itsfunctioning and required to achieve the purposes illustrated in the <span class="privacy-policy" @click="jumpUrl">privacy policy</span>. 
					By clicking, "Accept" or continuing to browse otherwise, 
					you agreeto the use of cookies.
				</type-text>
			</type-grid>
			<type-grid row="14" margin center>
				<type-button class="accept-button" round size="9" padding="0 30px" @click="closeTypeJ">
					Accept
				</type-button>
			</type-grid>
		</type-wrapper>
	</transition>
</template>

<script>
	// 接受隐私条款
	import mixin from '../mixin.js'
	export default {
		name: 'type-J',
		mixins: [ mixin ],
		data() {
			return {
				isShow: false
			}
		},
		created() {
			if (!this.$userInfo.data.accept) {
				this.isShow = true;
			}
		},
		methods: {
			jumpUrl() {
				const url = this.showData.url || 'https://webapp.xitohere.com';
				window.open(url, '_blank');
			},
			closeTypeJ() {
				this.isShow = false;
				this.$userInfo.setData({
					time: this.$time.now.timestamp,
					accept: true
				});
			}
		}
	}
</script>

<style scoped lang="less">
	.type-J{
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		background-color: #F6CFCC!important;
		position: fixed;
		z-index: 99;
		bottom: 0px;
		left: 0;
		.privacy-policy{
			color: #3276FF;
			cursor: pointer;
			text-decoration: underline;
			&:hover{
				color:  #FF0000;
			}
		}
		.accept-button{
			background-color: #3276FF;
		}
	}
	.slide-enter-active{
		bottom: -500px;
		animation: slide-enter 500ms linear 2000ms forwards;
	}
	@keyframes slide-enter{
		from{
			bottom: -500px;
		}
		to{
			bottom: 0px;
		}
	}
	.slide-leave-active{
		bottom: 0px;
		animation: slide-leave 500ms linear forwards;
	}
	@keyframes slide-leave{
		from{
			bottom: 0px;
		}
		to{
			bottom: -500px;
		}
	}
</style>
